@if (homeView) {
  <div class="news-home-view" [attr.data-item-id]="news.id" (click)="onNewsClick()" style="cursor: pointer;">
    @if (news.file) {
      <div class="news-image-home">
        <img [src]="imagesUrl + 'thumb/' + news.file"  [alt]="news.title" />
      </div>
    }
    <div class="news-title-home">{{ news.title }}</div>
  </div>
} @else {
  <div class="news-card" [attr.data-item-id]="news.id" (click)="onNewsClick()" style="cursor: pointer;">
    @if (news.file) {
      <div class="news-image" >
        <img [src]="imagesUrl + 'thumb/' + news.file" loading="lazy"  [alt]="news.title"  />
      </div>
    }
    <div class="news-content">
      <div class="news-title" >{{ news.title }}</div>
      <div class="news-intro" >{{ news.intro }}</div>
      <div class="news-time-ago" >{{ news.created | date: 'yyyy-MM-dd HH:mm' }}</div>
    </div>
  </div>
}
